import React, { FC, useState } from "react";

import { NavigationVideoTeachingMaterial } from "../../../../state";
import VolAccordion from "../VolAccordion";

import styles from "./SchoolLevelSection.module.scss";

type Props = {
  label: string;
  materials: NavigationVideoTeachingMaterial[];
  playingLessonVideoId: number | null;
  onVideoPlay: (videoId: number) => void;
};

const SchoolLevelSection: FC<Props> = ({
  label,
  materials,
  playingLessonVideoId,
  onVideoPlay,
}) => {
  const [openMaterialIds, setOpenMaterialIds] = useState<number[]>([]);
  const isAllOpen = materials.every(material =>
    openMaterialIds.includes(material.id),
  );

  const toggleMaterial = (materialId: number) => {
    setOpenMaterialIds(materialIds =>
      materialIds.includes(materialId)
        ? materialIds.filter(id => id !== materialId)
        : [...materialIds, materialId],
    );
  };

  const toggleAll = () => {
    setOpenMaterialIds(isAllOpen ? [] : materials.map(material => material.id));
  };

  return (
    <div className={styles.schoolSection}>
      <div className={styles.sectionHeader}>
        <p className={styles.schoolLevel}>{label}</p>
        <button
          className={styles.toggleAllButton}
          onClick={toggleAll}
          type="button"
        >
          {isAllOpen ? "すべて閉じる" : "すべて開く"}
        </button>
      </div>
      <div>
        {materials.map(material => (
          <VolAccordion
            isOpen={openMaterialIds.includes(material.id)}
            key={material.id}
            material={material}
            onVideoPlay={onVideoPlay}
            onToggle={() => toggleMaterial(material.id)}
            playingLessonVideoId={playingLessonVideoId}
          />
        ))}
      </div>
    </div>
  );
};

export default SchoolLevelSection;
